const columns = [
  {
    name: 'Material',
    selector: (row) => row.name,
  },
  {
    name: 'Actions',
    selector: (row) => row.actions,
  },
]

export default columns
